import { __assign, __read, __spread } from "tslib";
import React from "react";
import classNames from "classnames";
import { useDefaultValue } from "../form/controlled";
import { CheckContext } from "../check";
import { useConfig } from "../_util/config-context";
/**
 * 单选选项组，里面可以嵌套 <Radio />
 */
export function CheckboxGroup(props) {
    var classPrefix = useConfig().classPrefix;
    var _a = useDefaultValue(props, []), value = _a.value, onChange = _a.onChange, disabled = _a.disabled, layout = _a.layout, className = _a.className, style = _a.style, children = _a.children;
    var checkedSet = new Set(value || []);
    var context = {
        inject: function (checkProps) {
            // 只为 checkbox 提供
            if (checkProps.type !== "checkbox") {
                return checkProps;
            }
            // 如果已经受控，则不注入
            if (typeof checkProps.value === "boolean") {
                return checkProps;
            }
            var checkName = checkProps.name;
            if (typeof checkName === "undefined") {
                console.warn('<Checkbox> managed by <CheckboxGroup> must include the "name" prop');
                return checkProps;
            }
            return __assign(__assign({}, checkProps), { value: checkedSet.has(checkName), disabled: checkProps.disabled || disabled, display: layout === "column" ? "block" : "inline", onChange: function (checked, context) {
                    // 支持 checkbox 上的 onChange 处理时阻止默认的处理行为
                    if (typeof checkProps.onChange === "function") {
                        checkProps.onChange(checked, context);
                        if (context.event.defaultPrevented) {
                            return;
                        }
                    }
                    if (typeof onChange === "function") {
                        var newValue = checked
                            ? __spread(value, [checkName]) : (checkedSet.delete(checkName), Array.from(checkedSet));
                        onChange(newValue, context);
                    }
                } });
        },
    };
    return (React.createElement("div", { className: classNames(classPrefix + "-form-check-group", className), style: style },
        React.createElement(CheckContext.Provider, { value: context }, children)));
}
//# sourceMappingURL=CheckboxGroup.js.map